import React from "react";

import { IgTypography } from "@intelligems/ig-theme";
import { IgAlert } from "@src/components/Utils/IgAlert";
import { personalizationsDiscountSyncError } from "@src/utils/linkSheet";
import { openNewTab } from "@src/utils/openNewTab";

export const DiscountSyncErrorBanner = () => {
  return (
    <IgAlert
      severity={"error"}
      title={"Shopify Discount Synchronization Error"}
      longMessage={
        <IgTypography>
          You may need to remove or deactivate one or more of the automatic
          discounts in Shopify.
          <IgTypography
            sx={{ marginLeft: "10px" }}
            onClick={() =>
              openNewTab(
                personalizationsDiscountSyncError,
                "Discount synchronization error"
              )
            }
            igStyle={"link"}
          >
            Read more
          </IgTypography>
        </IgTypography>
      }
    />
  );
};
